import {Compiler, Component, ComponentRef, Injectable, NgModule, OnInit, ViewContainerRef} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentsModule} from '../components/components.module';
import {ButtonModule} from 'primeng/button';
import {FieldsetModule} from 'primeng/fieldset';
import {FieldService} from '../components/field/field/field.service';
import {ContentDataByDataviewDTO, Table} from '@tj/tj-dmp-lib-api';

@Injectable({
	providedIn: 'root'
})
export class BuildComponentService {

    private listDynCmpt: ComponentRef<any>[] = [];

    constructor(private compiler: Compiler, private fieldService: FieldService) {
    }

    public loadComponent(container: ViewContainerRef, template: string, context: any): Promise<ComponentRef<any>> {
       const fieldService = this.fieldService;
       return  new Promise((resolve, reject) => {
           const tmpCmp = Component({ template })(class DynCmp implements OnInit {
               data: ContentDataByDataviewDTO;
               tables: Table[];
               constructor() {
               }
               ngOnInit(): void {
                   fieldService.data = this.data;
                   fieldService.tables = this.tables;
               }
               getSubQuery(subQuery) {
                   return this.data.dataSubQuery[subQuery]?.content;
               }
           });
           const tmpModule = NgModule({ declarations: [tmpCmp],
               imports: [ CommonModule,
                   ComponentsModule,
                   ButtonModule,
                   FieldsetModule]
           })(class {});

           this.compiler.compileModuleAndAllComponentsAsync(tmpModule).then((factories) => {
               const componentFactory = factories.componentFactories[0];
               const componentRef = container.createComponent(componentFactory);
               this.listDynCmpt.push(componentRef);
               Object.assign(componentRef.instance, context);
               resolve(componentRef);
           });
       });

    }

    updateComponent(componentRef: ComponentRef<any>, context: { name: string }) {
        Object.assign(componentRef.instance, context);
    }

    destroy() {
        this.listDynCmpt.forEach(c => {
            c.destroy();
        });
        this.listDynCmpt = [];
    }
}
